import React, { useEffect, useState } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { PageLayout } from "./components/PageLayout";

export default function App() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const [token, setToken] = useState(null);

  useEffect(() => {
    function reAuth() {
      if (isAuthenticated) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          })
          .then((tokenresponse) => {
            setToken(tokenresponse);
          })
          .catch(function (err) {
            console.log(err);
            instance.logoutRedirect({
              postLogoutRedirectUri: "/",
              idTokenHint: accounts[0]?.idToken,
            });
          });
      }
    }
    reAuth();
    const interval = setInterval(() => {
      reAuth();
    }, 1800000);
    return () => clearInterval(interval);
  }, [accounts, instance, isAuthenticated]);

  return isAuthenticated ? (
    <PageLayout>
      <AuthenticatedTemplate>
        <Dashboard token={token} />
      </AuthenticatedTemplate>
    </PageLayout>
  ) : (
    <UnauthenticatedTemplate>
      <Login />
    </UnauthenticatedTemplate>
  );
}
